import React from 'react';
import s from './MyBtn.module.css'

type PropsType = {
    type?: "button" | "submit" | "reset",
    title: string,
    onClick?: () => void;
}

const MyBtn:React.FC<PropsType> = ({title, type, ...props}) => {
    return (
        <button type={type} className={s.my_btn} {...props}>
            {title}
        </button>
    );
};

export default MyBtn;
